/*! http://tinynav.viljamis.com v1.2 by @viljamis
  Modified by Johnny Martin */
(function ($, window, i) {
  $.fn.tinyNav = function (options) {

    // Default settings
    var settings = $.extend({
      'active' : 'selected', // String: Set the "active" class
      'header' : '', // String: Specify text for "header" and show header instead of the active item
      'indent' : '- ', // String: Specify text for indenting sub-items
      'label'  : '', // String: sets the <label> text for the <select> (if not set, no label will be added)
      'link_selector': 'a', // String: class to scan for links
      'opt_group': false // Indent items, or use opt groups
    }, options);

    return this.each(function () {

      // Used for namespacing
      i++;

      var $nav = $(this),
        // Namespacing
        namespace = 'tinynav',
        namespace_i = namespace + i,
        l_namespace_i = '.l_' + namespace_i,
        $select = $('<select/>').attr("id", namespace_i).addClass(namespace + ' ' + namespace_i);

      if ($nav.is('ul,ol')) {

        if (settings.header !== '') {
          $select.append(
            $('<option/>').text(settings.header)
          );
        }

        $nav.addClass('l_' + namespace_i);

        // Build options
        var options = '';

        if(settings.opt_group) {
          options = nested_opt_groups($nav);
        } else {
          $nav
          .find(settings.link_selector)
          .each(function () {
            options += '<option value="' + $(this).attr('href') + '">';
            var j;
            for (j = 0; j < $(this).parents('ul, ol').length - 1; j++) {
              options += settings.indent;
            }
            options += $(this).text() + '</option>';
          });
        }

        // Append options into a select
        $select.append(options);

        // Select the active item
        $select
          .find('option:eq(' + $(l_namespace_i + ' ' + settings.link_selector)
          .index($(l_namespace_i + ' ' + settings.link_selector + '.' + settings.active)) + ')')
          .attr('selected', true);

        // Change window location
        $select.change(function () {
          window.location.href = $(this).val();
        });

        // Inject select
        $('<div class="form-item">').insertAfter(l_namespace_i).append($select);

        // Inject label
        if (settings.label) {
          $select.before(
            $("<label/>")
              .attr("for", namespace_i)
              .addClass(namespace + '_label ' + namespace_i + '_label')
              .append(settings.label)
          );
        }

      }

    });

    function nested_opt_groups($nav) {
      var options = '';
      $nav.find('> li > ' + settings.link_selector)
      .each(function () {
        if($(this).next().is('ul, ol')) {
          options += '<optgroup label="' + $(this).text().trim() + '">';
          options += nested_opt_groups($(this).next());
          options += '</optgroup>';
        } else {
          options += '<option value="' + $(this).attr('href') + '">' + $(this).text().trim() + '</option>';
        }
      });

      return options;
    }

  };
})(jQuery, window, 0);
